import Vue from 'vue'
import Toasted from 'vue-toasted'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import VuetifyDialog from 'vuetify-dialog'
import 'vuetify-dialog/dist/vuetify-dialog.css'
import { hamiVuex } from './store/base'
import { stopPageLoading } from '@/plugins/pageLoading'

Vue.config.productionTip = false

Vue.use(Toasted, {
  position: 'bottom-center',
  duration: 5000,
  fullWidth: false,
})

// https://github.com/yariksav/vuetify-dialog
Vue.use(VuetifyDialog, {
  context: {
    vuetify,
  },
})

window.app = new Vue({
  store: hamiVuex.vuexStore,
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app')

window.document.title = '艺爪付费'
stopPageLoading()
